<template>
  <div class="form-group">
    <select v-model="featureProduct.feature_attribute_id" class="form-control custom-select">
      <option v-for="item in featureAttributes" :value="item.id">{{ item.value }}</option>
    </select>

    <template v-if="['list-with-text-value','list-with-number-value'].indexOf(featureType) > -1">
      <input :type="featureType ===  'list-with-number-value'? 'number':'text' " v-model.lazy="featureProduct.feature_value"
             class="form-control my-1"/>
    </template>

  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "FeatureInputList",
  props: {
    featureProduct: {},
    product: {},
  },
  computed: {
    featureAttributes() {
      return this.featureProduct.feature.feature_attributes
    },
    featureType() {
      return this.isCheckbox ? 'checkbox' : this.featureProduct.feature.type
    },
    isCheckbox() {
      return Array.isArray(this.featureProduct)
    },
  }
})
</script>
<style scoped>

</style>